module.exports = __webpack_public_path__ + "img/search-arrow.ac066bea.svg";